// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3b-KY","title":"AfterBackImages_title__gAh-G","images":"AfterBackImages_images__iKXvM"};